import dayjs from 'dayjs'

export function getDisplayDate(date) {
  return dayjs(date).format('MM-DD-YYYY')
}

export function getDisplayDateTime(dateTime) {
  
  return dateTime ? dayjs(dateTime).format('MMM D, YYYY h:mm a') : '-'
}